import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AdminLogin from "@/pages/AdminLogin";
import BuildOrdersPage from "@/pages/supervisor/BuildOrdersPage";
import SupervisorReportsPage from "@/pages/supervisor/SupervisorReportsPage";
import TechniciansPage from "@/pages/supervisor/TechniciansPage";
import StationsPage from "@/pages/supervisor/StationsPage";
import { LiveMonitorPage } from "@/pages/supervisor/LiveMonitorPage";
import {
  SettingsPage, NotificationsPage, ActivityLogPage,
} from "@/pages/supervisor/ComingSoonPage";
import TestingStandardsPage from "@/pages/supervisor/TestingStandardsPage";
import BuildReportsPage from "@/pages/supervisor/BuildReportsPage";
import BuildReportViewPage from "@/pages/supervisor/BuildReportViewPage";
import TechnicianLogin from "@/pages/TechnicianLogin";
import TechnicianStation from "@/pages/TechnicianStation";
import CustomerLive from "@/pages/CustomerLive";
import CustomerBuildReport from "@/pages/CustomerBuildReport";
import ComponentIssuesPage from "@/pages/supervisor/ComponentIssuesPage";
import SalesLogin from "@/pages/SalesLogin";
import SalesDashboard from "@/pages/SalesDashboard";
import Landing from "@/pages/Landing";
import "@/App.css";

function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <div className="p-8 text-white/50">Loading…</div>;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;
  return children;
}

function TechnicianRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <div className="p-8 text-white/50">Loading…</div>;
  if (!user || user.role !== "technician") return <Navigate to="/technician/login" replace />;
  return children;
}

function SalesRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <div className="p-8 text-white/50">Loading…</div>;
  if (!user || (user.role !== "sales" && user.role !== "admin")) return <Navigate to="/sales/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Navigate to="/supervisor/build-orders" replace />} />
            <Route path="/supervisor" element={<Navigate to="/supervisor/build-orders" replace />} />
            <Route path="/supervisor/build-orders"  element={<AdminRoute><BuildOrdersPage /></AdminRoute>} />
            <Route path="/supervisor/live-monitor"  element={<AdminRoute><LiveMonitorPage /></AdminRoute>} />
            <Route path="/supervisor/stations"      element={<AdminRoute><StationsPage /></AdminRoute>} />
            <Route path="/supervisor/technicians"   element={<AdminRoute><TechniciansPage /></AdminRoute>} />
            <Route path="/supervisor/reports"       element={<AdminRoute><SupervisorReportsPage /></AdminRoute>} />
            <Route path="/supervisor/build-reports" element={<AdminRoute><BuildReportsPage /></AdminRoute>} />
            <Route path="/supervisor/build-reports/:orderId" element={<AdminRoute><BuildReportViewPage /></AdminRoute>} />
            <Route path="/supervisor/component-issues" element={<AdminRoute><ComponentIssuesPage /></AdminRoute>} />
            <Route path="/supervisor/settings/testing-standards" element={<AdminRoute><TestingStandardsPage /></AdminRoute>} />
            <Route path="/supervisor/settings"      element={<AdminRoute><SettingsPage /></AdminRoute>} />
            <Route path="/supervisor/notifications" element={<AdminRoute><NotificationsPage /></AdminRoute>} />
            <Route path="/supervisor/activity-log"  element={<AdminRoute><ActivityLogPage /></AdminRoute>} />
            <Route path="/reports" element={<Navigate to="/supervisor/reports" replace />} />
            <Route path="/technician/login" element={<TechnicianLogin />} />
            <Route path="/technician" element={<TechnicianRoute><TechnicianStation /></TechnicianRoute>} />
            <Route path="/sales/login" element={<SalesLogin />} />
            <Route path="/sales" element={<SalesRoute><SalesDashboard /></SalesRoute>} />
            <Route path="/live/:token" element={<CustomerLive />} />
            <Route path="/report/:token" element={<CustomerBuildReport />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster theme="dark" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
